import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "IMAGE_VARIABLE", {
  EDITED: "Image variable edited succesfully",
  DELETED: "Image variable deleted succesfully",
});
